<template>
  <v-row align="center" no-gutters>
    <v-col cols="12" class="text-center">
      <v-btn
        block
        outlined
        class="text-body-1"
        :style="`background-color: ${color}; color: white;`"
        @click="internalShow = true"
      >
        {{ colorName }} ({{ color }})
      </v-btn>
    </v-col>
  </v-row>
  
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      required: true,
    },
    colorName: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      internalShow: this.show,
    }
  },
  watch: {
    show (newShow) {
      this.internalShow = newShow;
    },
    internalShow (newShow) {
      this.$emit('update:show', newShow);
    }
  }
}
</script>